"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLATFORM_SALE_SOURCE = void 0;
exports.PLATFORM_SALE_SOURCE = {
    CC_ETSY: 'CC_ETSY',
    CHIC_ETSY: 'CHIC_ETSY',
    MC: 'MC',
    SF_ETSY: 'SF_ETSY',
    FMF: 'FMF',
    FMF_ETSY: 'FMF_ETSY',
    TEST: 'CC_ETSY',
    FMF_FB: 'FMF_FB'
};
//# sourceMappingURL=platformSaleSources.js.map